<template>
  <div class="container">
    <FinancialData />

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Student History Search</div>
          <div class="panal-body">
            <b-row>
           <!-- <b-col>
                <label for="example-datepicker">Start Due Date</label>
                <b-form-datepicker
                  id="Start"
                  v-model="startDate"
                  class="mb-2"
                ></b-form-datepicker>
              </b-col>
              <b-col>
                <label for="example-datepicker">End Due Date</label>
                <b-form-datepicker
                  id="End"
                  class="mb-2"
                  v-model="endDate"
                ></b-form-datepicker>
              </b-col> -->
              <b-col cols="12" class="mt-3 text-center">
                <b-form-radio-group
                  v-model="search"
                
                >
                  <b-form-radio value="['Credit'+'Debit']" checked>All</b-form-radio>
                  <b-form-radio value="Debit">Debit</b-form-radio>
                  <b-form-radio value="Credit">Credit</b-form-radio>
                </b-form-radio-group>
                <!-- <div class="mt-3 text-right">
                   @click="AddDate"
                  <b-button variant="success">Search</b-button>
                </div> -->
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Grid</div>
          <div class="panal-body">
            <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Payment Type</th>
                    <th scope="col">Credit/Debit</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Due Date</th>
                    <th scope="col">Payment Date</th>
                    <th scope="col">Charge Status</th>
                    <th scope="col">Note</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="empty">
                    <td colspan="2">No Data</td>
                  </tr>
                  <tr
                    v-else
                    v-for="item in paymentMethod"
                    v-bind:Key="item.StudentID"
                  >
                    <td>{{ item.PaymentType }}</td>

                    <td>
                
                      <span
                       
                        class="badge-success badge"
                         :class="{'badge-warning' : (item, item.CreditOrDebit=='Debit') }"
                        >{{ item.CreditOrDebit}}</span
                      >
                    </td>
                    <td>{{ item.Amount }}</td>
                    <td>{{ item.DueDate }}</td>
                    <td>{{ item.PaymentDate }}</td>
                    <td>{{ item.ChargeStatus }}</td>
                    <td>{{ item.Notes }}</td>
                  </tr>
        
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FinancialData from "../../components/Financial/FinancialData.vue";
import studentData from '../../services/student/studentDataServices';
    export default {
      components: {
      FinancialData,
  
  },
        name: 'StudentHistorySearch',
          data() {
      return {
        selected: null,
        show: true,
        isHidden: false,
        FinancialHistory:[],
        search:'',
        empty: false,
        // endDate:null,
        // startDate:null,
    
        
      }
      
    },

    computed:{
           currenUser(){
            return  this.$store.state.auth.user
          },

     paymentMethod: function(){

         return this.FinancialHistory.filter((item) =>{
         return item.CreditOrDebit.match(this.search)

 });

 

         } 

        //  filterDate: function () {

        //    var vm = this
        //    var startDate = vm.startDate;
        //    var endDate = vm.endDate;
        //    return FinancialHistory.filter(vm.FinancialHistory.item,(function(FinancialHistory){
        //      if((startDate) && (endDate)){
        //         return true
        //      }
        //       else {
        //      var date= FinancialHistory.date;
        //      return (date >= startDate && date <= endDate);
        //    }
        //    }
         
        //    )) 
           
        //  }

    
       },

      //  methods:{

     
             

      //  },

       mounted(){
      
      //this.currenUser.StudentID  // 4 
            studentData.GetStudentFinancialHistory(this.currenUser.StudentID,'1/1/0001','1/1/0001',null).then(Response =>{
              // this.isLoading = false ;
               this.FinancialHistory = Response.data
               // this.empty =false
               //Response.OnlineReceipt
                // eslint-disable-next-line no-console
                  console.log('StudentFinancialHistory => ',this.FinancialHistory )
           },
         error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       
       
       },


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}
.badge {
  padding: 0.65em 0.6em;
}
</style>
